import { loc } from "../../../../../core/utils"
import { node, string } from "prop-types"
import React from "react"
import { Row } from "react-bootstrap"

export default function OldProductRenewal({ oldProductName, products, children }) {
  return (
    <Row>
      <div>{`${loc("Renewal product")} ${oldProductName} ${loc("to product")} ${products}`}</div>
    </Row>
  )
}

OldProductRenewal.propTypes = {
  children: node,
  oldProductName: string,
  products: string
}
